const config = {
	apiDomain: 'https://demo.engage.local',
	portalDomain: 'http://localhost:3000'
};
module.exports = config;



// WEBPACK FOOTER //
// ./src/config/config.js